import React from 'react';
import 'antd-mobile/dist/antd-mobile.css';
import { Wrapper, Container } from './style';
import { getNoToken } from '../../utils/request';
import { Toast, Modal } from 'antd-mobile';
import Config from '../../config';

class Loading extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // 本地（王力测试公众号）
      url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx22a1f0da54a37d32&redirect_uri=http%3A%2F%2F192.168.1.94%3A3000&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect',
      
      // 线上测试（水母）
      url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04bfeaa4425042ae&redirect_uri=http%3A%2F%2Ftestpgy.360ivf.com%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect',
      // 线上正式（水母）
      url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04bfeaa4425042ae&redirect_uri=http%3A%2F%2Fpgy.360ivf.com%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect',
      // 线上测试分享（水母）
      url: 'http://testpgy.360ivf.com/#/home1',
      url: 'http://testpgy.360ivf.com/#/pregnCalculat1',
      // 线上正式分享（水母）
      url: 'http://pgy.360ivf.com/#/home1',
      url: 'http://pgy.360ivf.com/#/hompregnCalculat1e1',

      // 线上测试（IVF）
      url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd97304f19a086804&redirect_uri=http%3A%2F%2Ftestpgy.sgwy.360ivf.com%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect',
      // 线上正式（IVF）
      url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd97304f19a086804&redirect_uri=http%3A%2F%2Fpgy.sgwy.360ivf.com%2F&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect',
      // 线上测试分享（IVF）
      url: 'http://testpgy.sgwy.360ivf.com/#/home2',
      url: 'http://testpgy.sgwy.360ivf.com/#/pregnCalculat11',
      // 线上正式分享（IVF）
      url: 'http://pgy.sgwy.360ivf.com/#/home2',
      url: 'http://pgy.sgwy.360ivf.com/#/pregnCalculat11',
    }
  }
  async componentDidMount() {
    let code = this.getUrlParam('code')
    let params = {code}
    let res = await getNoToken(`/pgy/user/${Config.appId}/greet`, params)
    if(res.data.code == 100){
      if(res.data.biz_code == 1000){
        console.log('没有加入后台')
        let openid = res.data.data.openid
        let url = `${window.location.origin}/#/login/${openid}`
        window.location.replace(url)
      } else if(res.data.biz_code == 1100){
        console.log('没关注公众号')
        Modal.alert('提示', '请先关注该公众号', [
          {text: '关闭', onPress: () => {
            console.log('关闭')
            window.WeixinJSBridge.call('closeWindow')
          }}
        ])
      } else if(res.data.biz_code == 20000){
        console.log('检测到账号')
        let token = res.data.data.token
        window.localStorage.setItem('token', token)
        let url = `${window.location.origin}/#/list`
        window.location.replace(url)
      } else {
        Toast.info(res.data.msg)
      }
    } else {
      Toast.info(res.data.msg)
    }
  }
  reload(){
    let appid = 'wx22a1f0da54a37d32'
    let encode = encodeURIComponent(window.location.href)
    let authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encode}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    window.location.replace(authUrl)
  }
  getUrlParam(name){
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let url = window.location.href.split('#')[0]
    let search = url.split('?')[1]
    if (search) {
      var r = search.substr(0).match(reg)
      if (r !== null) return unescape(r[2])
      return null
    } else {
      return null
    }
  }
  render() {
    return (
      <Wrapper>
        <Container>
          
        </Container>
      </Wrapper>
    );
  }
}
export default Loading;